


import { removeMerchantToken } from "../../common";
import { merchantTokenName } from "../../config";

const getMerchantUserFromLocalStorage = () => {
    try {
        const merchant = JSON.parse(sessionStorage.getItem(merchantTokenName));
        if (merchant && merchant.authToken && merchant.loggedInTime) {
            console.log("Returning merchant User:", merchant);
            return merchant;
        } else {
            removeMerchantToken();
            return null
        }
    } catch (error) {
        removeMerchantToken()
        return null
    }
};


const getInitial = () => {
    return getMerchantUserFromLocalStorage();
};

const merchantreducer = (state = getInitial(), action) => {
    switch (action.type) {
        case "LOGIN_MERCHANT":
            state = {};
            const time = action.payload.loggedInTime;
            if (time) {
                state.loggedInTime = time;
            } else {
                state.loggedInTime = Date.now();
            }
            state.authToken = action.payload.authToken;
            sessionStorage.setItem(merchantTokenName, JSON.stringify(state));
            return state;
        case "LOGOUT_MERCHANT":
            removeMerchantToken();
            return null;
        default:
            return state;
    }
};

export default merchantreducer;